var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.67962 1.98705L2.95956 1.70711C3.35008 1.31658 3.98325 1.31658 4.37377 1.70711L7.62623 4.95956C8.01675 5.35008 8.01675 5.98325 7.62623 6.37377L6.31704 7.68296C6.12771 7.87229 6.08077 8.16154 6.20051 8.40102C7.58495 11.1699 9.8301 13.4151 12.599 14.7995C12.8385 14.9192 13.1277 14.8723 13.317 14.683L14.6262 13.3738C15.0168 12.9832 15.6499 12.9832 16.0404 13.3738L19.2929 16.6262C19.6834 17.0168 19.6834 17.6499 19.2929 18.0404L19.013 18.3204C16.9016 20.4317 13.559 20.6693 11.1703 18.8777L8.62857 16.9714C6.88504 15.6638 5.33622 14.115 4.02857 12.3714L2.12226 9.82968C0.330722 7.44096 0.568269 4.0984 2.67962 1.98705Z",
    stroke: "#0079FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.68f305ff83cc67ead80400f1de33d3f9.svg";
export { ForwardRef as ReactComponent };